/**
 * created by lei lei on 2020/5/31
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Card, Icon, Avatar,Popconfirm } from 'antd';
/*import activity from './img/u210.png'
import topic from './img/u210.png'*/
import activity from './img/ding.png'
import topic from './img/j2.png'
import { Object } from 'core-js';
const { Meta } = Card;
const gridStyle = {
    width: '25%',
    textAlign: 'center',
}
export default class NewActivityPending extends Component {
    static defaultProps = {
        showPoint:true,
        pointColor:'red',
        customWidth:250,
        showX:false,
        iconType:1,
        statusMarkStatus:true,
        statusMark:'请放入字段',
        content:'',
    }
    static propTypes = {
        title: PropTypes.string.isRequired, //标题
        //icon : PropTypes.string, //图标
        content:PropTypes.string.isRequired,//内容
        statusMark:PropTypes.string.isRequired,//描述
        timeMark:PropTypes.string.isRequired,//描述
        showPoint:PropTypes.bool,//是否显示点
        pointColor:PropTypes.string,//红点的颜色
        onClickItem:PropTypes.func,//点击每一项
        customWidth:PropTypes.number,//自定义宽度自适应页面的时候自己给宽度适应
        showX:PropTypes.bool,//是否显示X
        onRemoveItem:PropTypes.func,//点击删除
        
    }

    constructor(props) {
        super(props);
        this.state = {
            img:''
         
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps !== this.props){
            this.renderIcon()
        }
    }

    componentDidMount() {
        this.renderIcon()

    }

    onRemoveItem(){
        this.props.onRemoveItem&&this.props.onRemoveItem()
    }

    renderIcon = () => {
        let img ;
        if(this.props.iconType===1){
            img= <Avatar style={{height:16,width:16}} src={activity} />
        } else {
            if(this.props.lockStatus){
                img = <Icon type="lock" theme="filled" style={{ fontSize:17, color: this.props.newSecondSelectColor  }}  twoToneColor={this.props.newSecondSelectColor} />
            } else {
                img =  <Avatar style={{height:16,width:16}} src={topic}/>
            }
        }
        this.setState(()=> {
            return{
                img
            }
        })
    }

    render() {
        let pointColor='#BFBFBF'
        if(this.props.statusMark){
            if(this.props.statusMark.indexOf('已发布') > -1 ||this.props.statusMark.indexOf('已采用') > -1){
                pointColor='#00A854'
            }
            if(this.props.statusMark.indexOf('已领取') > -1 || this.props.statusMark.indexOf('已提交') > -1||this.props.statusMark.indexOf('进行中') > -1){
                pointColor='#0E77D1'
            }
            if(this.props.statusMark.indexOf('未领取') > -1){
                pointColor='#BFBFBF'
            }
            if(this.props.statusMark.indexOf('弃用') > -1 ||this.props.statusMark.indexOf('撤回') > -1){
                pointColor='#ffa455'
            }
            if(this.props.statusMark.indexOf('已超期') > -1){
                pointColor='#FF0000'
            }
        }

        return (
            
            <div style={{position:'relative', boxSizing: 'border-box'}}>
                {
                 
                    <Card style={{ height: 150, background:'#f8fafd'}} bordered={false}
                    hoverable={true}
                      bodyStyle={{padding:0, height:'100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}
                >
                    {this.props.showX?  <Popconfirm style={{position:'relative'}} onConfirm={()=>this.onRemoveItem()}  title="是否忽略此提醒" okText="确认" cancelText="取消">
                            <div style={{width:20,position:'absolute',right:7,cursor:'pointer',lineHeight:'45px'}}>
                                <Icon style={{fontSize:16}} type="delete" />
                            </div></Popconfirm>
                        :null}
                    <Meta
                        style={{fontSize:12,background:'#f8fafd',lineHeight:'45px',paddingLeft:15, display: 'flex', alignItems: 'center'}}
                        avatar={this.state.img}
                        onClick={()=>{
                            this.props.onClickItem()
                        }}
                        title={<span style={{fontSize:15, fontFamily: 'MicrosoftYaHei-Bold', color: '#333333', fontWeight: 'bold'}}>{this.props.title}</span>}
                    />
                    <div  title={this.props.content} onClick={()=>{
                        this.props.onClickItem()
                    }} style={{ wordWrap:"break-word", wordBreak:"normal",fontSize:14, fontFamily:'MicrosoftYaHei', color:'#666666',
                    overflow:'hidden',textOverflow:'ellipsis',display:'-webkit-box',WebkitLineClamp:2,WebkitBoxOrient:'vertical',marginBottom: 10,paddingLeft:20,paddingRight:20,height:42}}>{this.props.content} </div>
                        <div style={{color:'rgba(0,0,0,.45)',height:20,lineHeight:'20px',marginTop:0,paddingLeft:5,paddingRight:20}}>
                            {/*显示红点的时候，显示背景*/}
                            {this.props.showPoint?  <div style={{display:'-webkit-inline-box',float:"left", minWidth:"56px"}}>
                                <div style={{height:20,lineHeight:'20px',fontSize:12,color:'#ffffff',marginLeft:10,width:'100%', textAlign:"center", right:0,background:pointColor,borderRadius:10,}}>{this.props.statusMark}</div>
                            </div>:this.props.statusMark}

                        {/*    {this.props.showPoint? <div style={{width:8,height:8,background:pointColor,borderRadius:'50%',marginTop:7,float:'left'}}></div>:null}
                            {this.props.statusMark}*/}
                                <span style={{flex: '0 0 auto',float: 'right',color:'#999999'}} title={this.props.timeMark}>{this.props.timeMark}</span>

                        </div>
                </Card> 
                }
             
            </div>
        )
    }
}

